import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useDropboxChooser } from '../../hooks';

type P = {
  children: ReactNode;
  onCancel?: () => void;
  onDropdownClose?: () => void;
  onSelect: (data: Array<{ link: string; name: string }>) => void;
  opened: boolean;
};

const DropboxChooser = ({ children, onCancel, onDropdownClose, onSelect, opened }: P) => {
  const { choose } = useDropboxChooser();

  useEffect(() => {
    if (!opened) {
      return;
    }

    if (choose(onSelect, onCancel)) {
      onDropdownClose?.();
    }
  }, [opened, choose, onSelect, onCancel, onDropdownClose]);

  return <>{children}</>;
};

export default DropboxChooser;
